import React from 'react'
import { Modal, Form, Select, DatePicker, Input, Button, theme } from 'antd'
import { PlusOutlined, CloseOutlined } from '@ant-design/icons'
import { hexToRGBA } from '../../../../lib/utils'

const { Option } = Select

const CreateReminderModal = ({ isVisible, onCancel, onAdd, form, filterValues }) => {
  const { token } = theme.useToken()
  const { categories, departments, priorities } = filterValues || {
    categories: [],
    departments: [],
    priorities: ['Critical', 'High', 'Medium', 'Low']
  }

  return (
    <Modal
      title='Create New Reminder'
      visible={isVisible}
      onCancel={onCancel}
      footer={[
        <Button
          key='cancel'
          onClick={onCancel}
          icon={<CloseOutlined style={{ color: token.colorError }} />}
          style={{
            background: hexToRGBA(token.colorError, 0.1),
            borderColor: token.colorError,
            color: token.colorError
          }}
        >
          Cancel
        </Button>,
        <Button
          key='submit'
          onClick={onAdd}
          icon={<PlusOutlined style={{ color: token.colorSuccess }} />}
          style={{
            background: hexToRGBA(token.colorSuccess, 0.1),
            borderColor: token.colorSuccess,
            color: token.colorSuccess,
            fontWeight: 'bold'
          }}
        >
          Create Reminder
        </Button>
      ]}
      width={600}
    >
      <Form form={form} layout='vertical'>
        <Form.Item
          name='reminderTitle'
          label='Reminder Title'
          rules={[{ required: true, message: 'Please enter a title' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name='staffId'
          label='Staff Member'
          rules={[{ required: true, message: 'Please select a staff member' }]}
        >
          <Select placeholder='Select staff member' showSearch optionFilterProp='children'>
            <Option value='STAFF-123'>Nurse Sarah Collins (STAFF-123)</Option>
            <Option value='STAFF-145'>Nurse Michael Chen (STAFF-145)</Option>
            <Option value='STAFF-167'>Nurse Amanda Rodriguez (STAFF-167)</Option>
            {/* More options would be populated from staff database */}
          </Select>
        </Form.Item>

        <Form.Item name='category' label='Category' rules={[{ required: true, message: 'Please select a category' }]}>
          <Select placeholder='Select category'>
            {categories.map((category) => (
              <Option key={category} value={category}>
                {category}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name='department'
          label='Department'
          rules={[{ required: true, message: 'Please select a department' }]}
        >
          <Select placeholder='Select department'>
            {departments.map((dept) => (
              <Option key={dept} value={dept}>
                {dept}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name='priority' label='Priority' rules={[{ required: true, message: 'Please select priority' }]}>
          <Select placeholder='Select priority'>
            {priorities.map((priority) => (
              <Option key={priority} value={priority}>
                {priority}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name='reminderDate'
          label='Reminder Date/Time'
          rules={[{ required: true, message: 'Please specify date and time' }]}
        >
          <DatePicker showTime={{ format: 'HH:mm' }} format='YYYY-MM-DD HH:mm' style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          name='reminderDetails'
          label='Details'
          rules={[{ required: true, message: 'Please enter reminder details' }]}
        >
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default CreateReminderModal
